import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';


function _privateKeyFilter(k){
    if(/^_/.test(k)) return false;
    if(/^u?id$/.test(k)) return false;
    if(k == 'history') return false;
    if(k == 'meta') return false;
    if(k == 'timeline') return false;
    return true;
}
@Component({
  selector: 'app-conflict-mediator',
  templateUrl: './conflict-mediator.component.html',
  styleUrls: ['./conflict-mediator.component.scss'],
})
export class ConflictMediatorComponent implements OnInit,OnChanges {


  @Input() type:string;
  @Input() data:any;
  keys:string[]=[];
  values:any[]=[];
  revs:string[]=[];
  selectedData:Map<string,any>=new Map<string,any>();
  updatedDocument:any;
  @Output() onRepair:EventEmitter<any> = new EventEmitter<any>();
  constructor() { }
  _updateDoc(){
    let {_id,_rev} = this.data;
    let master = {...this.data};
    Object.keys( master ).forEach( ( key )=>{
      if(/^_/.test(key)){
        delete master[key];
      }
    });
    master._id = _id;
    this.selectedData.forEach( (  value, combokey )=>{
      let [rev,key] = combokey.split('|');
      master[key]=value;
    })
    this.updatedDocument = master;
    console.log('updateDoc!')
  }
  submit(){
    this._updateDoc();
    this.onRepair.emit( {
      updateData: {...this.updatedDocument},
      staleRevs: [...this.revs]
    } );
  }
  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes',{type:this.type,data:this.data});
    const {type,data} = this;
    this._tearDown();
    if(!data) return;
    let allowedKeys = Object.keys(data).filter(_privateKeyFilter);
    allowedKeys.unshift('_id');
    let updateDoc = {};
    allowedKeys.forEach( ( key )=>{
      updateDoc[key] = data[key];
    });


    if(type == 'sector'){
      this._loadSector();
    }else if(type =='pile'){
      this._loadPile();
    }
    this._updateDoc();
  }
  _tearDown(){
    this.keys = [];
    this.values=[];
    this.revs=[];
    this.selectedData = new Map<string,any>();
    this.updatedDocument=null;
  }
  _simplifyConflictNo(n:string){
    let no = n.split('-')[0];
    let rev = n.split('-')[1].slice(0,3);
    return `v${no}-${rev}`
  }
  _getRealValue(rev:string,key:string){
    let data;
    if(rev == this.data._rev){
      data = this.data;
    }else{
      data = this.data._revisions.find( (r)=>{
        return r._rev == rev;
      })
    }
    return data;
  }
  _getValues(rev:string,key:string,updatedDocument?:any){
    let data;
    if(updatedDocument){
      data = updatedDocument;
    }else{

      data = this._getRealValue(rev,key);
    }
    if(!data) return;
    if(!data[key]) return;
    if(key =='roadInfo'){
      let values = Object.keys(data[key]).map( ( rn:string )=>{
        let rd = data[key][rn];
        return Object.values(rd).join('');
      });
      return values.join(', ')
    }
    if( key == 'measures'){
      let height = data.measures.heights.length  == 1 ? data.measures.heights.length : (data.measures.heights.reduce((a,b)=>a+b))/data.measures.heights.length;
      height = Number( Number(height).toFixed(2) );
      return `${data.measures.logLength}" × ${data.measures.length}m × ${height}m`
    }
    if( key == 'essence'){
      return `${data.essence.name} (${data.essence.code})`
    }
    if( key == 'position'){
      return `${data.position.latitude||'--'},${data.position.longitude||'--'}`
    }
    let stringified = JSON.stringify(data[key], (k,value)=>{
      if(Array.isArray(value)) return value.join(', ');
      if(/\d+-\d+-\d+T/.test(value)){
        return value.split('T')[0];
      }
      return value;
    })
    return stringified ? stringified.replace(/^\"|\"$/g,'') : stringified;
  }
  isChecked( rev, key ){
    let combokey = `${rev}|${key}`;
    return this.selectedData.has(combokey);
  }
  checkedChanged( isChecked, rev, key, row){
    let combokey = `${rev}|${key}`;
    let nodes = Array.from(row.querySelectorAll('ion-checkbox'));

    if(isChecked){
        let realValue = this._getRealValue(rev,key);

        this.selectedData.set(combokey, realValue[key] );

        nodes.forEach( ( sibling:any )=>{
          if(sibling.value.rev != rev ){
            sibling.checked=false;
          }
        });
    }else{
      let checkedNode =  nodes.find( ( sibling:any )=>{
          return sibling.value.rev != rev && sibling.checked
      });
      if(checkedNode){
        this.selectedData.delete(combokey)
      }else{
        let recheck:any = nodes.find( (sibling:any)=>{
          return sibling.value.rev == rev;
        });
        if(recheck){
          recheck.checked = true;
        }
      }
    }
      this._updateDoc();

  }
  _loadSector(){

    let masterKeys = Object.keys( this.data).filter( _privateKeyFilter ).sort();
    let childKeys:any = new Set<string>();
    let childValues:any = {};
    let revs:string[ ] = [this.data._rev].concat( this.data._conflicts );
    this.data._revisions.forEach( ( rev:any )=>{
      let revKeys = Object.keys( rev ).filter( _privateKeyFilter ).sort();
      revKeys.forEach( ( rk )=>{
        childKeys.add( rk );
        if(!childValues[rk]){
          childValues[rk] = [];
        }
        childValues[rk].push( JSON.stringify( rev[rk]))
      });

    });

    childKeys = Array.from(childKeys);
    this.keys = masterKeys.filter( ( mk )=>{
      let isChildKey:any = childKeys.includes( mk );
      if(isChildKey){
        let mainValue:any = JSON.stringify(this.data[mk]);
        let otherValues = childValues[mk]||[];
        console.log('othervalues',otherValues)
        let allValues:any =  otherValues.concat(mainValue||null);
        let hasDiffValues:boolean = !allValues.reduce(function(a, b){ return (a === b) ? a : NaN; });
        return isChildKey && hasDiffValues;
      }
      return isChildKey;



    });
    this.revs = revs;
    this.keys.forEach( ( key )=>{
      let combokey = `${this.data._rev}|${key}`;
      this.selectedData.set(combokey, this.data[key]);
    });
    console.log('_loadSector',{ revs,masterKeys, childKeys});
  }
  stringify(b){
    return JSON.stringify(b, null, 2);
  }
  _loadPile(){
    let masterKeys = Object.keys( this.data).filter( _privateKeyFilter ).filter( k=>k!='sector').sort();
    let childKeys:any = new Set<string>();
      let childValues:any = {};
    let revs:string[ ] = [this.data._rev].concat( this.data._conflicts );
    this.data._revisions.forEach( ( rev:any )=>{
      let revKeys = Object.keys( rev ).filter( _privateKeyFilter ).sort();
      revKeys.forEach( ( rk )=>{
        childKeys.add( rk );
        if(!childValues[rk]){
          childValues[rk] = [];
        }
        childValues[rk].push( JSON.stringify( rev[rk]))
      });
    });
    childKeys = Array.from(childKeys);
    this.keys = masterKeys.filter( ( mk )=>{
      let isChildKey:any = childKeys.includes( mk );
      if(isChildKey){
        let mainValue:any = JSON.stringify(this.data[mk]);
        let otherValues = childValues[mk]||[];
        console.log('othervalues',otherValues)
        let allValues:any =  otherValues.concat(mainValue||null);
        let hasDiffValues:boolean = !allValues.reduce(function(a, b){ return (a === b) ? a : NaN; });
        return isChildKey && hasDiffValues;
      }
      return isChildKey;



    });
    this.revs = revs;
    this.keys.forEach( ( key )=>{
      let combokey = `${this.data._rev}|${key}`;
      this.selectedData.set(combokey, this.data[key]);
    });
    console.log('_loadSector',{ revs,masterKeys, childKeys});
  }
  ngOnInit() {}


}
